import { Api } from "../../common/js/api";

export default new class CartItem {
    constructor() {
        this.cartItem = '[data-cart-item]';

        if (!$(this.cartItem).length) return;

        this.conf = {
            countStep: 0.1,
            fadePopupTimeout: 250,
            areaMaxValue: 10000,
            areaMinValue: 0.1
        };

        this.confirmPopup = `<div class="cart-item__confirm-popup" data-cart-item-confirm-popup>
                                <div class="cart-item__confirm-popup-text">Удалить товар из корзины?</div>
                                <button type="button" class="cart-item__confirm-popup-btn _agree" data-cart-item-confirm-popup-btn="agree">Да</button>
                                <button type="button" class="cart-item__confirm-popup-btn _cancel" data-cart-item-confirm-popup-btn="cancel">Отмена</button>
                            </div>`;

        this.cartItemCounter = '[data-cart-item-counter]';
        this.cartItemArea = '[data-cart-item-area]';
        this.cartItemPriceVal = '[data-cart-item-price-val]';
        this.cartItemOldPriceVal = '[data-cart-item-price-old]';
        this.cartListTotalPrice = '[data-cart-list-total-price]';
        this.cartListTotalOldPrice = '[data-cart-list-total-old]';

        this.cartItemDelete = '[data-cart-item-delete]';
        this.cartItemDeleteBtn = '[data-cart-item-delete-btn]';

        this.cartItemConfirmPopup = '[data-cart-item-confirm-popup]';
        this.cartItemConfirmPopupBtn = '[data-cart-item-confirm-popup-btn]';

        this.classShow = '_show';

        this.eventsHandler();
        this.calculateTotalPrice();
    }

    eventsHandler() {
        let $doc = $(document);

        $doc.on('click', this.cartItemCounter, (e) => {
            e.preventDefault();
            this.changeAreaValue($(e.currentTarget));
        });

        $doc.on('click', this.cartItemDeleteBtn, (e) => {
            e.preventDefault();
            this.showConfirmPopup($(e.currentTarget));
        });

        $doc.on('click', this.cartItemConfirmPopupBtn, (e) => {
            e.preventDefault();
            this.popupAction($(e.currentTarget));
        });

        $doc.on('input', this.cartItemArea, (e) => {
            this.checkAreaValue($(e.currentTarget));
            this.calculateTotalPrice();
        })
    }

    checkAreaValue($area) {
        if ($area.val() > this.conf.areaMaxValue) {
            $area.val(this.conf.areaMaxValue);
        }
    }

    popupAction($btn) {
        let actionType = $btn.data('cart-item-confirm-popup-btn');

        switch (actionType) {
            case 'agree':
                this.deleteCartItem($btn);
                break;
            case 'cancel':
                this.hideConfirmPopup($btn);
                break;
        }
    }

    deleteCartItem($btnDelete) {
        let $item = $btnDelete.closest(this.cartItem);
        let itemId = $item.data('cart-item-id');

        $item.remove();
        // MigrationHelper.reduceHeaderCartCounter(); // TODO Add new product list for connect react components
        Api.removeProductFromCart(itemId);
        this.calculateTotalPrice();
    }

    hideConfirmPopup($btnCancel) {
        let $confirmPopup = $btnCancel.closest(this.cartItemConfirmPopup);

        $confirmPopup.removeClass(this.classShow);
        setTimeout(() => {
            $confirmPopup.remove();
        }, this.conf.fadePopupTimeout)
    }

    showConfirmPopup($btnDelete) {
        if ($(this.cartItemConfirmPopup).length) $(this.cartItemConfirmPopup).remove();

        let $itemDeleteWrap = $btnDelete.closest(this.cartItemDelete);

        $itemDeleteWrap.append(this.confirmPopup);
        setTimeout(() => {
            $itemDeleteWrap.find(this.cartItemConfirmPopup).addClass(this.classShow)
        }, this.conf.fadePopupTimeout);

    }

    changeAreaValue($counter) {
        let counterType = $counter.data('cart-item-counter'),
            $area = $counter.closest(this.cartItem).find(this.cartItemArea),
            areaVal = +$area.val(),
            newVal;

        if (counterType === 'plus') {
            newVal = areaVal + this.conf.countStep;
        } else {
            newVal = areaVal - this.conf.countStep;
        }

        if (newVal < this.conf.areaMinValue) return;

        $area.val(newVal.toFixed(1));
        this.calculateTotalPrice();
    }

    calculateTotalPrice() {
        let arItems = $(this.cartItem),
            totalPrice = 0;

        arItems.each((i, item) => {
            totalPrice += this.calculateItemPrice($(item));
            this.calculateItemPrice($(item), 'old');
        });

        $(this.cartListTotalPrice).text(Math.round(totalPrice));
    }

    calculateItemPrice($cartItem, priceType) {
        let priceVal = this.cartItemPriceVal,
            dataName = 'cart-item-price-val',
            itemPrice,
            itemAmount,
            totalItemPrice;

        if (priceType === 'old') {
            priceVal = this.cartItemOldPriceVal;
            dataName = 'cart-item-price-old';
        }

        itemPrice = +$cartItem.find(priceVal).data(dataName);
        itemAmount = $cartItem.find(this.cartItemArea).val();
        totalItemPrice = Math.round(itemAmount * itemPrice);

        $cartItem.find(priceVal).text(totalItemPrice);
        
        return isNaN(totalItemPrice)
            ? 0
            : totalItemPrice; 
    }
}
